import { LinkWithChevron } from '#components/Link/LinkWithChevron';

import styles from './ShortNewsArticlesLinks.module.scss';
import type { ShortnewsArticleFragment } from './fragments/__generated__/ShortnewsArticle.generated';

type Props = {
	shortNewsList: Omit<ShortnewsArticleFragment, '__typename'>[];
	className?: string;
};

export function ShortNewsArticlesLinks({ shortNewsList, className = '' }: Props) {
	return (
		<ul className={`${className} body1`}>
			{shortNewsList.map((article) => {
				return (
					<li className={styles.listItem} id={article.id} key={article.id}>
						<LinkWithChevron href={`/meldung${article.path}`}>
							<span className={`${styles.title}`}>{article.title}</span>
						</LinkWithChevron>
					</li>
				);
			})}
		</ul>
	);
}
